import React from "react";

import {
  SingleSelectDropdown as Dropdown,
  SingleSelectDropdownItem
} from "@widgets/inputs/dropdown/singleselect.jsx";
import {
  MultiSelectDropdownItem,
  MultiSelectDropdown as MultiDropdown,
  DROPDOWN_TYPE,
  DROPDOWN_SIZES
} from "@widgets/inputs/dropdown/multiselect.jsx";

/** Props are similar to SingleSelectDropdown component in widgets/web/src/inputs/dropdown/singleselect.jsx. */
export function SingleSelectDropdown(props) {
  return (
    <Dropdown
      {...props}
      size={DROPDOWN_SIZES.MEDIUM}
      type={DROPDOWN_TYPE.NORMAL}
    />
  );
}

SingleSelectDropdown.Item = SingleSelectDropdownItem;

/** Props are similar to MultiSelectDropdown component in widgets/web/src/inputs/dropdown/multiselect.jsx */
export function MultiSelectDropdown(props) {
  return (
    <MultiDropdown
      {...props}
      size={DROPDOWN_SIZES.MEDIUM}
      type={DROPDOWN_TYPE.NORMAL}
    />
  );
}

MultiSelectDropdown.Item = MultiSelectDropdownItem;
